module.exports = __webpack_public_path__ + "img/uk-genitourinary-diseases-male.39fa1e42.png";